<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Observaciones"
          label-for="observaciones"
          :description="descripcion">
          <b-form-textarea
            id="observaciones"
            v-model="$v.observaciones.$model" 
            rows="5"
            max-rows="5"
            :state="observacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="observacionesFeedback">
            {{ observacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'Observaciones',
  props: {
    // maxLength: {
    //   type: Number,
    //   default: 5000,
    // },
    descripcion: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      observaciones: '',
      
      noValidar: true,
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      labelCols: 2,
    }
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
            // this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta ' + this.maxLength.toString().trim() + ' caracteres';
          }      
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;


      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        let params = {
          observaciones: this.observaciones,
        }
        this.$emit('save', params)
      }
    },
    cancelar() {
      this.$emit('cancelar')
    },
  },
  validations: {
    observaciones: {
      maxLength: maxLength(5000)
      // maxLength: maxLength(this.maxLength)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
